export default __webpack_public_path__ + "static/media/an.41cd9bf6.png";